/**
 * Name of the decoy form field. Deliberately not a plausible CMS field name, so
 * a configured form field can never collide with it and trip the trap for a
 * real person.
 */
export const HONEYPOT_FIELD = "hp_url";
